import Notifier from './Notifier';
import connect from './connect';

export default connect(Notifier);



// WEBPACK FOOTER //
// ./src/components/Notifier/index.js